import React from "react";
import { useSearchParams } from "react-router-dom";
import Presenter from "./Presenter";

import { useQuery } from "@apollo/client";
import { DELIVERY_SEARCH_LIST_QUERY } from "../../../../Config/Queries/Search";

const Container = () => {
  const [searchParams] = useSearchParams();

  const keyword = searchParams.get("keyword")
    ? searchParams.get("keyword")
    : "";
  const page = searchParams.get("page") ? +searchParams.get("page") : 1;
  const take = 20;
  const baseUrl = "/search/result/products";

  const { loading, error, data } = useQuery(DELIVERY_SEARCH_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      keyword,
      take,
      skip: (page - 1) * take,
    },
  });

  // if (loading) {
  //   return <></>;
  // }
  if (error) {
    return <>{error.message}</>;
  }

  return (
    <Presenter
      keyword={keyword}
      page={page}
      take={take}
      loading={loading}
      data={data}
      baseUrl={baseUrl}
    />
  );
};

export default Container;
